module.exports = __webpack_public_path__ + "static/media/payment-card-number.5eb19f14.svg";